// extracted by mini-css-extract-plugin
export default {"btn":"WhiteButton_btn__+7v9j","count":"WhiteButton_count__qNMYU"};